// @flow

import React from 'react';
import type { SearchCoursesResultsProps } from '../../utils/types';

const ResultsList = ({
  results,
  translations /*,vocabulary,*/,
}: SearchCoursesResultsProps) => {
  return (
    <React.Fragment>
      {results.map(
        ({
          '@id': url,
          UID,
          title,
          year,
          location,
          course_class,
          course_type,
          course_venue,
          access_type,
          double_title,
          department,
          course_language,
          external_website,
        }) => {
          double_title = double_title != null ? double_title : 'no';

          return (
            <div className="course-item" key={UID}>
              <div className="course-title">
                <a href={external_website || url} title={title}>
                  <h2>{title}</h2>
                </a>{' '}
                {course_type ? (
                  <span className="course-type">
                    {course_type.title /*vocabulary.CourseTypes[course_type]*/}
                  </span>
                ) : (
                  ''
                )}
              </div>

              <div className="course-header">
                {course_type ? (
                  <div className="column">
                    <div className="icon">
                      <i className="fas fa-user-graduate" />
                    </div>
                    <div>
                      <h5>{translations.course_type_label}</h5>
                      {
                        course_type.title /*vocabulary.CourseTypes[course_type]*/
                      }
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {course_class ? (
                  <div className="column">
                    <div className="icon">
                      <i className="fas fa-tag" />
                    </div>
                    <div>
                      <h5>{translations.course_class_label}</h5>
                      <span>
                        {
                          course_class.title /*vocabulary.CourseClass[course_class]*/
                        }
                      </span>
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {access_type ? (
                  <div className="column">
                    <div className="icon">
                      <i className="fas fa-sign-in-alt" />
                    </div>
                    <div>
                      <h5>{translations.access_type_label}</h5>
                      {access_type.title /*vocabulary.AccessType[access_type]*/}
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {course_venue ? (
                  <div className="column">
                    <div className="icon">
                      <i className="fas fa-map-marker-alt" />
                    </div>
                    <div>
                      <h5>{translations.course_venue_label}</h5>
                      <span>
                        {course_venue.title /*vocabulary.Venue[course_venue]*/}
                      </span>
                      {location ? (
                        <div className="address">{location}</div>
                      ) : (
                        ''
                      )}
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {course_language ? (
                  <div className="column">
                    <div className="icon">
                      <i className="fas fa-globe" />
                    </div>
                    <div>
                      <h5>{translations.course_language_label}</h5>
                      <span>
                        {
                          course_language.title /*vocabulary.CourseLanguage[course_language]*/
                        }
                      </span>
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {double_title.token == 'si' ? (
                  <div className="column">
                    <div className="icon">
                      <i className="fas fa-graduation-cap" />
                    </div>
                    <div>
                      <h5>{translations.double_title_label}</h5>
                      {
                        double_title.title /*vocabulary.DoubleTitle[double_title]*/
                      }
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {year && year.length ? (
                  <div className="column">
                    <div className="icon">
                      <i className="fas fa-calendar-alt" />
                    </div>
                    <div>
                      <h5>{translations.course_year_label}</h5>
                      <span>{year}</span>
                    </div>
                  </div>
                ) : (
                  ''
                )}

                {department ? (
                  <div className="column">
                    <div className="icon">
                      <i
                        className={
                          department +
                          ' fas fa-landmark' +
                          ' ' +
                          department.token
                        }
                      />
                    </div>
                    <div>
                      <h5>{translations.course_department_label}</h5>
                      {department.title /*vocabulary.Departments[department]*/}
                    </div>
                  </div>
                ) : (
                  ''
                )}
              </div>
            </div>
          );
        },
      )}
    </React.Fragment>
  );
};

const SearchCoursesResults = ({
  results,
  translations,
  vocabulary,
}: SearchCoursesResultsProps) => {
  const noResultsLabel =
    translations && translations.no_results_label
      ? translations.no_results_label
      : '';
  //console.log(translations);
  const body =
    results && results.length === 0 ? (
      <p className="no-results">{noResultsLabel}</p>
    ) : (
      <ResultsList
        results={results}
        translations={translations}
        vocabulary={vocabulary}
      />
    );
  return <div className="search-results-list">{body}</div>;
};

export default SearchCoursesResults;
